import DashboardDateUtil from "../util/DashboardDateUtil";
import {Http} from "oca-lib-web";
import moment from "moment";

export default class FlurryUsageAPI {

    private static usageUri = "https://api-metrics.flurry.com/public/v1/data/appUsage/{0}/app;show=all";

    public static get(startDate:string, endDate:string, interval:string, apiKeys:Array<string>): Promise<Array<FlurryUsageModel>> {
        return new Promise(async(resolve, reject) => {
            let query = {};
            query["token"] = process.env.REACT_APP_FLURRY_API_KEY;
            query["metrics"] = "sessions,activeDevices,activeUsers,newDevices,timeSpent,averageTimePerDevice,averageTimePerSession,medianTimePerSession";
            query["dateTime"] = DashboardDateUtil.convertFlurryDate(startDate, interval) + "/" + DashboardDateUtil.convertFlurryDate(endDate, interval);
            query["filters"] = "app|apiKey-in[" + apiKeys.join(",") + "]";

            let flurryUsageUri = this.usageUri.replace("{0}", DashboardDateUtil.getDateInterval(interval));
            let results;
            try {
                results = await Http.get(flurryUsageUri, query);
                console.log(results);
            } catch (e) {
                console.error("Error fetching data from flurry", e);
            }

            if (results?.status == 400) {
                console.error(results.reason, results.description);
                resolve([]);
                return;
            } else if (!results || !results.rows) {
                console.error("No rows returned");
                resolve([]);
                return;
            }

            // this gets it for all apps
            let usages: Array<any> = [];
            for (let result of results.rows) {
                let usage: any = {
                    //dateTime: result["dateTime"],
                    date: moment(result["dateTime"]).format("YYYYMMDD"),
                    apiKey: result["app|apiKey"],
                    appName: result["app|name"],
                    sessions: result["sessions"],
                    activeDevices: result["activeDevices"],
                    activeUsers: result["activeUsers"],
                    newDevices: result["newDevices"],
                    timeSpent: result["timeSpent"],
                    averageTimePerDevice: result["averageTimePerDevice"],
                    averageTimePerSession: result["averageTimePerSession"],
                    medianTimePerSession: result["medianTimePerSession"]
                };

                usages.push(usage);
            }

            return resolve(usages);
        });
    }
}